import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import * as Yup from "yup";

import Input from "./bannerInput";
import Button from "./button";
import { useTranslation } from "i18n";

import { changePassword } from "api/Auth";

const ChangePassword = ({ setChangePass }) => {
  const { t } = useTranslation();
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [succeed, setSucceeded] = useState(false);

  const validationSchemaEmail = Yup.object().shape({
    oldPassword: Yup.string().min(6).required().label(t("account.oldPassword")),
    newPassword: Yup.string().min(6).required().label(t("account.newPassword")),
    confirmPassword: Yup.string()
      .min(6)
      .oneOf([Yup.ref("newPassword"), null], t("account.passwordsMustMatch"))
      .required()
      .label(t("account.confirmPassword")),
  });

  const handelSubmitChangePass = async (values) => {
    setLoading(true);
    setErr("");
    setSucceeded(false);
    const body = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };

    const res = await changePassword({
      body,
    });
    if (!res.ok) {
      setErr(res?.data?.errorDetails);
    } else {
      setSucceeded(t("account.passwordChanged"));
    }
    setLoading(false);
  };

  return (
    <>
      {err && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {err}
        </Alert>
      )}

      {succeed && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {succeed}
        </Alert>
      )}
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={validationSchemaEmail}
        onSubmit={handelSubmitChangePass}
      >
        {({
          handleChange,
          handleSubmit,
          errors,
          setFieldTouched,
          touched,
          values,
          setFieldValue,
        }) => (
          <>
            <Input
              onChange={(e) => {
                const value = e.target.value || "";
                setFieldValue("oldPassword", value);
              }}
              error={touched.oldPassword && errors.oldPassword}
              onBlur={() => setFieldTouched("oldPassword")}
              name={"oldPassword"}
              mandatory={true}
              type="password"
              label={t("account.enterOldPassword")}
            />

            <hr />

            <Input
              onChange={(e) => {
                const value = e.target.value || "";
                setFieldValue("newPassword", value);
              }}
              error={touched.newPassword && errors.newPassword}
              onBlur={() => setFieldTouched("newPassword")}
              name={"newPassword"}
              mandatory={true}
              type="password"
              label={t("account.enterNewPassword")}
            />

            <Input
              onChange={(e) => {
                const value = e.target.value || "";
                setFieldValue("confirmPassword", value);
              }}
              error={touched.confirmPassword && errors.confirmPassword}
              onBlur={() => setFieldTouched("confirmPassword")}
              name={"confirmPassword"}
              mandatory={true}
              type="password"
              label={t("account.enterConfirmPassword")}
            />
            <Box display="inline-flex" gab={2} mt={2}>
              <Button
                type="submit"
                onClick={handleSubmit}
                className="bigBtn primary-color"
              >
                {loading ? (
                  <CircularProgress sx={{ color: "#fff" }} size={22} />
                ) : (
                  t("account.changePassword")
                )}
              </Button>
              <Button onClick={() => setChangePass(false)} className="bigBtn">
                {t("common.cancel")}
              </Button>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
};

export default ChangePassword;
